import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Settings } from 'lucide-react';

/**
 * Small gear button that navigates a rep to `/library?tab=prompts` — the
 * Prompts tab where they can view the team default AI prompt and (if they've
 * saved one) their own personal override. Shared by two mount points (U5,
 * U9): ContactDetailPanels' Contact Intelligence panel (via
 * `FlowDetailPanel.headerAction`) and AccountIntelPanel's Summary tab (mounted
 * inside its own toggle strip, since that panel lives outside FlowDetail —
 * see Key Technical Decision 13).
 */
export function PromptSettingsGear({ ariaLabel }: { ariaLabel: string }) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      title="Manage AI prompt"
      onClick={() => navigate('/library?tab=prompts')}
      className="text-content-tertiary hover:text-content-primary dark:text-nightshade-500 dark:hover:text-nightshade-100"
    >
      <Settings size={12} />
    </button>
  );
}
